// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bv1b66{padding-left:var(--ds-space-050,4px)}\n._u5f31b66{padding-right:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
